export const FETCH_AFFILIATE_LIST = {
  START: "FETCH_AFFILIATE_LIST_START",
  SUCCESS: "FETCH_AFFILIATE_LIST_SUCCESS",
  ERROR: "FETCH_AFFILIATE_LIST_ERROR",
};

export const TOAST = {
  RESET: "RESET_AFFILIATE_TOAST",
};

export const FETCH_AFFILIATE_INIT = "FETCH_AFFILIATE_INIT";

export const SET_DELETE_CONFIRMATION_POPUP_VISIBILITY =
  "SET_AFFILIATE_DELETE_CONFIRMATION_POPUP_VISIBILITY";

export const INIT_CREATE_AFFILIATE_SCREEN = "INIT_CREATE_AFFILIATE_SCREEN";

export const CREATE_AFFILIATE = {
  START: "CREATE_AFFILIATE_START",
  SUCCESS: "CREATE_AFFILIATE_SUCCESS",
  ERROR: "CREATE_AFFILIATE_ERROR",
};

export const EDIT_AFFILIATE = {
  START: "EDIT_AFFILIATE_START",
  SUCCESS: "EDIT_AFFILIATE_SUCCESS",
  ERROR: "EDIT_AFFILIATE_ERROR",
};

export const FETCH_AFFILIATE_DETAIL = {
  START: "FETCH_AFFILIATE_DETAIL_START",
  SUCCESS: "FETCH_AFFILIATE_DETAIL_SUCCESS",
  ERROR: "FETCH_AFFILIATE_DETAIL_ERROR",
};

export const EXPORT_AFFILIATE = {
  START: "EXPORT_AFFILIATE_START",
  SUCCESS: "EXPORT_AFFILIATE_SUCCESS",
  ERROR: "EXPORT_AFFILIATE_ERROR",
};

export const AFFILIATE_DD = {
  START: "AFFILIATE_DD_START",
  SUCCESS: "AFFILIATE_DD_SUCCESS",
  ERROR: "AFFILIATE_DD_ERROR",
};

export const AFFILIATE_SAVE_TABLE_STATE = "AFFILIATE_SAVE_TABLE_STATE";

export const CURRENCY_CODE_DD = {
  START: "CURRENCY_CODE_DD_START",
  SUCCESS: "CURRENCY_CODE_DD_SUCCESS",
  ERROR: "CURRENCY_CODE_DD_ERROR",
};

export const AFFILIATE_LOCATION_WITH_AFFILIATE_DD = {
  START: "AFFILIATE_LOCATION_WITH_AFFILIATE_DD_START",
  SUCCESS: "AFFILIATE_LOCATION_WITH_AFFILIATE_DD_SUCCESS",
  ERROR: "AFFILIATE_LOCATION_WITH_AFFILIATE_DD_ERROR",
};
